const { default: axios } = require("axios");
const loadPermissions = () => {

  const response  = axios({
    url:"/roles/get-modules",
    method:"GET",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
    }
  }).then((response) => {
    console.log(response.data)
    return response.data
  })
  return response

}

const savePermission = (formData) => {
  const url = formData._id?'roles/update-role':'/roles/create-role'
  const method = formData._id? "PUT":"POST"
  const response  = axios({
    url:url,
    data:formData,
    method:method,
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response.data;
  })
  return response

}

const loadRoles = (params) => {
  let qParams = new URLSearchParams(params).toString();
  const response  = axios({
    url:`/roles?${qParams}`,
    method:"GET",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
    }
  }).then((response) => {
    return response.data
  })
  return response

}

const loadRole = (id) => {

  const response  = axios({
    url:`/roles/get-role/${id}`,
    method:"GET",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
    }
  }).then((response) => {
    return response.data
  })
  return response

}

const allActiveRoles = () => {

  const response  = axios({
    url:"/roles/all-active-role",
    method:"GET",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
    }
  }).then((response) => {
    return response.data
  })
  return response

}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  savePermission,
  loadPermissions,
  allActiveRoles,
  loadRoles,
  loadRole
}